import { render } from "./CollectionsTopbar.vue?vue&type=template&id=b2c42a40"
import script from "./CollectionsTopbar.vue?vue&type=script&lang=js"
export * from "./CollectionsTopbar.vue?vue&type=script&lang=js"

import "./CollectionsTopbar.vue?vue&type=style&index=0&id=b2c42a40&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__